
import axios from 'axios';
import { baseURL } from './baseUrl';
// let baseURL = process.env.REACT_APP_BASE_URL;

export default axios.create({
  baseURL: baseURL,

headers: {
  'Content-type': 'application/json',
  // 'Access-Control-Allow-Origin':"*",
}, 
});
